import React, { useLayoutEffect, useRef, useState } from 'react';
import "../Css/Home.css";
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// import required modules
import { Pagination, Navigation } from 'swiper/modules';
import HomeProduct from '../Component/ProductSlider/HomeProduct';
import Footer from '../Component/FooterComponent/Footer';
import bannervideo from "../Images/Banner/1 FIVE BANNER VIDEO.mp4";
import { IoPlay, IoPause, IoVolumeMute, IoVolumeHigh } from 'react-icons/io5';
const Home = () => {
    const bannerVideoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(true);
    const [isMuted, setIsMuted] = useState(true);

    // useLayoutEffect(() => {
    //     window.scrollTo(0, 0)
    // });

    const handleToggleMute = () => {
        const nextMuted = !isMuted;

        if (bannerVideoRef.current) {
            bannerVideoRef.current.muted = nextMuted;
        }

        setIsMuted(nextMuted);
    };

    const handleTogglePlay = () => {
        if (!bannerVideoRef.current) {
            return;
        }

        if (isPlaying) {
            bannerVideoRef.current.pause();
        } else {
            bannerVideoRef.current.play();
        }

        setIsPlaying(!isPlaying);
    };

    return (
        <>
            <section className='Home-Section-01'>
                <div className='Home-Section-Banner-main-con'>
                    <Swiper
                        spaceBetween={30}
                        centeredSlides={true}
                        pagination={{
                            clickable: true,
                        }}
                        navigation={true}
                        modules={[Pagination, Navigation]}
                        className="mySwiper"
                    >
                        <SwiperSlide>
                            <div className='Home-Banner-con-details-Image'>
                                <video
                                    ref={bannerVideoRef}
                                    className='Home-Banner-video'
                                    src={bannervideo}
                                    autoPlay
                                    muted
                                    loop
                                    playsInline
                                    onPlay={() => setIsPlaying(true)}
                                    onPause={() => setIsPlaying(false)}
                                />
                                <div className='Home-Banner-details-info-con'>
                                    <button
                                        type='button'
                                        className='Home-Banner-audio-btn Home-Banner-audio-btn-left'
                                        onClick={handleToggleMute}
                                        aria-label={isMuted ? 'Unmute video' : 'Mute video'}
                                    >
                                        {isMuted ? <IoVolumeMute /> : <IoVolumeHigh />}
                                    </button>
                                    <button
                                        type='button'
                                        className='Home-Banner-audio-btn Home-Banner-cta-btn'
                                        onClick={handleTogglePlay}
                                        aria-label={isPlaying ? 'Pause video' : 'Play video'}
                                    >
                                        {isPlaying ? <IoPause /> : <IoPlay />}
                                    </button>
                                    {/* <div className='Home-Banner-details-info'>
                                        <div className='Home-Banner-details-text-con'>
                                            <h3>Black Addiction</h3>
                                        </div>
                                        <div className='Home-Section-Btn-Main-con'>
                                            <div className='Home-Section-Btn-con'>
                                                <Link to="/women">
                                                    <button>
                                                        shop women
                                                    </button>
                                                </Link>
                                            </div>
                                            <div className='Home-Section-Btn-con'>
                                                <Link to="/men">
                                                    <button>
                                                        shop men
                                                    </button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </SwiperSlide>
                        {/* <SwiperSlide>
                            demo
                        </SwiperSlide> */}
                    </Swiper>
                </div>
            </section>

            <HomeProduct />
            <Footer />
        </>
    )
}

export default Home